module.exports = __webpack_public_path__ + "static/media/ic_active_trial.35a9c257.svg";